import { useQuery } from "@tanstack/react-query";
import { fetchServices } from "../services/rateCards";

export const useServices = () =>
  useQuery({
    queryKey: ["services"],
    queryFn: fetchServices,
    staleTime: 1000 * 60 * 5,
  });
